module.exports = __webpack_public_path__ + "img/圆角矩形 1@2x.db8979da.png";